import { z } from "zod";
const kinds = z.enum(["shoot", "plan", "consent", "consent_reply", "card_finish", "card_year", "card_shoot", "booking"]);
export const aggregateProperties = {
  anonymous_visit: z.object({ channel: z.enum(["web", "toss"]) }).strict(),
  first_value: z.object({ entry: z.enum(["home", "event", "discover", "share"]) }).strict(),
  return_visit: z.object({ gap: z.enum(["1d", "2-7d", "8-30d", "31d+"]) }).strict(),
  share_created: z.object({ kind: kinds }).strict(),
  share_opened: z.object({ kind: kinds }).strict(),
  offer_intent: z.object({ offer: z.enum(["event-pass-30d", "pro-yearly"]) }).strict(),
  offer_viewed: z.union([z.object({projectStatus:z.enum(["project_limit","shoot_limit"])}).strict(),z.object({route:z.literal("/plan")}).strict()]),
  event_dated: z.object({ source: z.enum(["event", "manual"]) }).strict(),
} as const;
export type AggregateName = keyof typeof aggregateProperties;
